import { Button } from '@/shared/components'
import { scrollbarStyle } from '@/shared/styles'
import { pxToRem } from '@/shared/styles/themes'
import { Grid, styled, Typography } from '@mui/material'

export const StyledContainer = styled('div')`
  height: 100%;
`

export const StyledHeader = styled(Typography)`
  padding: 0 ${pxToRem(8)};
  font-size: ${pxToRem(16)};
  font-weight: 500;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-letter{
    text-transform: capitalize
  }
`

export const StyledButtonsContainer = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: ${pxToRem(4)} ${pxToRem(8)};
`

export const StyledAddButton = styled(Button)`
  margin-right: ${pxToRem(8)};
`

export const StyledDescription = styled(Typography)`
  padding: 0 ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  color: ${({ theme }) => theme.palette.text.secondary};
  color: ${({ theme }) => theme.palette.text.secondary};
  padding-top: ${pxToRem(4)};

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledLeftPane = styled('div')`
  height: calc(100dvh - ${pxToRem(62)} - ${pxToRem(16)});
  padding-top: ${pxToRem(16)};
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
`

export const StyledRightPane = styled('div', { shouldForwardProp: (prop) => prop !== '$visible' }) <{ $visible: boolean }>`
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: ${({ $visible }) => $visible ? 'block' : 'none'};
  height: calc(100dvh - ${pxToRem(62)} - ${pxToRem(32)});
  padding: ${pxToRem(16)} ${pxToRem(8)};
  overflow-y: auto;
  ${scrollbarStyle}
`
